// extracted by mini-css-extract-plugin
export var orderDetails = "_o6-2";
export var orderImage = "_o6-1";
export var orderMeta = "_o6-3";
export var orderSummary = "_o6-0";
export var rightArrow = "_o6-4";